import EdsFilterUserOptionsUpdatedEvent from '@/features/eds/events/EdsFilterUserOptionsUpdatedEvent';
import EdsFiltersSearchParamsUpdatedEvent from '@/features/eds/events/EdsFiltersSearchParamsUpdatedEvent';
import EdsValidationOverrideFieldDefinitionsEvent from '@/features/eds/events/EdsValidationOverrideFieldDefinitionsEvent';
import EdsValidationSetFieldEvent from './EdsValidationSetFieldEvent';

export const EdsValidationEvents = {
  OverrideFieldDefinitions: EdsValidationOverrideFieldDefinitionsEvent,
  SetField: EdsValidationSetFieldEvent,
};

export const EdsFilterEvents = {
  UserOptionsUpdated: EdsFilterUserOptionsUpdatedEvent,
  SearchParamsUpdated: EdsFiltersSearchParamsUpdatedEvent,
};
